import type { DashMailDay } from "./types";

type MailDaysProps = {
  days?: DashMailDay[];
};

export function MailDays({ days }: MailDaysProps) {
  const rows = days ?? [];
  return (
    <section className="fx-panel fx-mail" aria-label="E-mails partis">
      <div className="fx-panel__head">
        <h2>E-mails</h2>
        <span className="fx-mail__hint">14 jours · heure de Paris</span>
      </div>
      {rows.length === 0 ? (
        <p className="fx-panel__empty">Les envois du jour s’afficheront ici.</p>
      ) : (
        <div className="fx-mail__grid">
          {rows.map((row) => (
            <div className="fx-mail__row" key={row.day}>
              <span>{row.label}</span>
              <span className={row.sent > 0 ? "is-ok" : ""}>{row.sent} parti{row.sent === 1 ? "" : "s"}</span>
              <span className={row.failed > 0 ? "is-bad" : ""}>
                {row.failed} erreur{row.failed === 1 ? "" : "s"}
                {row.failed_numbers.length > 0 ? <small>{row.failed_numbers.join(" · ")}</small> : null}
              </span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
